import { convertUrlToParamsObject, toPersian } from '@/helpers/props'
import { filters, moreFilters } from '../../hooks/useMoreFilters'
import { checkIsWhiteLabel } from '@/helpers/checkEnvironments'

export const getText = ({ queryParams, city, province, village }) => {
  const seoData = getSeoTexts({ queryParams })
  const seoTitle = seoData[0]?.seoTitle || ''

  if ((seoData.length === 1 && city) || province) {
    if (city) {
      return `اجاره ویلا و سوئیت ${seoTitle} در ${city}`
    } else {
      return `اجاره ویلا و سوئیت ${seoTitle} در استان ${province}`
    }
  }
  if (city || province) {
    if (city) {
      return `اجاره ویلا و سوئیت در ${city}`
    } else {
      return `اجاره ویلا و سوئیت در استان ${province}`
    }
  } else if (village) {
    return `اجاره ویلا، سوئیت و کلبه در ${village}`
  } else if (seoData.length === 1) {
    return `اجاره ویلا و سوئیت ${seoTitle}`
  }
}

export const selectedMoreFilters = queryParams => {
  const list = moreFilters.flatMap(item => item.list).map(item => item.query)
  const selected = {}
  Object.entries(queryParams).forEach(([key, value]) => {
    if (value) {
      if (list?.includes(key as string)) {
        selected[key] = value
      }
    }
  })
  return selected
}

export const clearFilters = queryParams => {
  const list = [...filters, ...moreFilters.flatMap(item => item.list)].map(
    item => item.query,
  )
  const queries = {}
  Object.entries(queryParams).forEach(([key, value]) => {
    queries[key] = list?.includes(key as string) ? undefined : value
  })
  return queries
}

export const updateQueries = ({ form, setQueryParams, onClose }) => {
  const list = moreFilters.flatMap(item => item.list)
  const query = {}

  list.forEach(item => {
    const field = form[item.query]
    if (field) {
      query[item.query] = item.qValue ?? field
    } else {
      query[item.query] = undefined
    }
  })
  setQueryParams(query)
  onClose()
}

export const getSeoTexts = ({ queryParams }) => {
  const list = moreFilters.flatMap(item => item.list)
  const selected = Object.keys(selectedMoreFilters(queryParams))
  const selectedSeoItems: typeof list = []

  list.forEach(item => {
    if (item.seo && selected?.includes(item.query)) {
      selectedSeoItems.push(item)
    }
  })

  return selectedSeoItems
}

export const mainQueryLength = queryParams => {
  const mainFilters = [
    'apartment',
    'boomgardi',
    'cottage',
    'swiss-cottage',
    'pool',
    'indoor_pool',
    'outdoor_pool',
    'barbecue',
    'balcony',
    'billiard-pool',
    'coastal',
    'desert',
    'forest',
    'mountain',
    'mid_term',
  ]

  const existedMainFilters = mainFilters.filter(item => queryParams?.[item])

  if (existedMainFilters.length === 1) {
    if (!!queryParams.warm_water_pool && !queryParams.pool) {
      return 2
    }
  }
  return existedMainFilters.length
}

const seoFilterText = queryParams => {
  const list = getSeoTexts({ queryParams })

  const mainFilters = [
    'apartment',
    'boomgardi',
    'cottage',
    'swiss-cottage',
    'pool',
    'indoor_pool',
    'outdoor_pool',
    'barbecue',
    'balcony',
    'billiard-pool',
    'coastal',
    'desert',
    'forest',
    'mountain',
    'mid_term',
  ]

  const existedMainFilters = mainFilters.filter(item => queryParams?.[item])

  let poolSeoTitle = ''
  if (existedMainFilters.length <= 1) {
    if (!!queryParams.warm_water_pool || !!queryParams.pool) {
      poolSeoTitle = 'استخردار'
    }
  }

  return list?.length === 1 ? list?.[0]?.seoTitle : poolSeoTitle
}

export const getFilteredText = queryParams => {
  const texts = {
    default: 'ویلا و سوئیت',
    cottage: 'کلبه چوبی و جنگلی',
    apartment: 'روزانه آپارتمان و خانه مبله',
    mid_term: 'هفتگی، ماهانه و سالانه خانه و آپارتمان مبله',
    boomgardi: 'اقامتگاه بوم گردی',
    'swiss-cottage': 'کلبه سوئیسی (مثلثی)',
  }

  const mainFilters = [
    'apartment',
    'boomgardi',
    'cottage',
    'swiss-cottage',
    'pool',
    'indoor_pool',
    'outdoor_pool',
    'barbecue',
    'balcony',
    'billiard-pool',
    'coastal',
    'desert',
    'forest',
    'mountain',
    'mid_term',
  ]

  const existedMainFilters = mainFilters.filter(item => queryParams?.[item])

  if (existedMainFilters.length === 1) {
    if (!!queryParams.warm_water_pool && !queryParams.pool) {
      return texts.default
    }
  } else if (existedMainFilters.length > 1) {
    return texts.default
  }

  switch (true) {
    case queryParams.apartment !== undefined:
      return texts.apartment
    case queryParams.cottage !== undefined:
      return texts.cottage
    case queryParams.boomgardi !== undefined:
      return texts.boomgardi
    case queryParams['swiss-cottage'] !== undefined:
      return texts['swiss-cottage']
    case queryParams['mid_term'] !== undefined:
      return texts['mid_term']

    default:
      return texts.default
  }
}

export const getFilteredH1 = ({
  queries,
  city,
  province,
  data,
  placeName = '',
  village,
}) => {
  const { page, from, from_map_nearby: fromMapNearby, ...queryParams } = queries
  let type = getFilteredText(queryParams)
  let reserveText = 'اجاره'

  if (type === 'هفتگی، ماهانه و سالانه خانه و آپارتمان مبله') {
    type = 'ماهانه خانه'
  }

  if (placeName) {
    return `اجاره روزانه خانه و سوئیت در ${placeName} تهران`
  }

  if (queryParams.parent_id) {
    return data?.parent?.title ? `${data?.parent?.title}` : ''
  }

  if (village) {
    return `اجاره ویلا، سوئیت و کلبه در ${village}`
  }

  if (type === 'اقامتگاه بوم گردی') {
    reserveText = 'رزرو'
  }
  const texts = {
    province: `${reserveText} %t% %f% در استان ${province}`,
    city: `${reserveText} %t% %f% در ${city}`,
    default: `${reserveText} %t% %f%`,
  }

  let text = ''
  let filter = ''
  let result = ''
  let length = 0

  if (city) {
    text = texts.city
  } else if (province) {
    text = texts.province
  } else {
    text = texts.default
  }

  const list = {
    pool: 'استخردار',
    warm_water_pool: 'استخردار',
    outdoor_pool: 'استخر رو باز',
    indoor_pool: 'استخر سرپوشیده',
    barbecue: ' باربیکیو (منقل)',
    balcony: 'تراس دار (بالکن)',
    forest: 'جنگلی',
    mountain: 'کوهستانی',
    desert: 'کویری',
    coastal: 'ساحلی',
    'billiard-pool': 'با میزبیلیارد',
  }

  // default filters
  Object.entries(list).forEach(([key, value]) => {
    if (queryParams[key]) {
      filter = value
      length += 1
    }
  })

  if (queryParams.near_cities) {
    return `اجاره ویلا و سوئیت اطراف ${queryParams.near_cities}`
  }

  // pool filters
  if (queryParams.warm_water_pool) {
    filter = 'استخردار'
    length = 1
  }

  text = text.replace('%t%', `${type}`)

  if (length === 1) {
    result = text.replace('%f%', ` ${filter} `)
  } else if (city || province) {
    result = text.replace('%f%', '')
  } else {
    result = text.replace('%f%', '')
  }

  if (mainQueryLength(queryParams) > 1) {
    let completedText = ''
    if (province) {
      completedText = `در استان ${province}`
    } else if (city) {
      completedText = `در ${city}`
    }
    return `اجاره ویلا و سوئیت ${completedText}`
  }

  return result.replace(/\s{2,}/g, ' ').trim()
}

const getParentDetails = data => {
  let parentTitle = `%n% %c%`

  if (data?.parent?.city) {
    parentTitle = parentTitle.replace('%c%', `در شهر ${data?.parent?.city}`)
  }

  if (data?.parent?.title) {
    parentTitle = parentTitle.replace('%n%', data?.parent?.title)
  }

  return parentTitle
}
const isWhiteLabel = checkIsWhiteLabel()
export const getTitle = ({
  queryParams,
  city,
  province,
  minPrice,
  href,
  data,
  placeName,
  village,
}) => {
  const type = getFilteredText(queryParams)
  const shabTitle = isWhiteLabel ? '' : '|شب'
  let reserveText = 'اجاره'

  const { cottage, boomgardi } = queryParams || {}
  let unit = 'واحد'
  if (mainQueryLength(queryParams) <= 1) {
    if (cottage && !boomgardi) unit = 'کلبه'
    if (boomgardi && !cottage) unit = 'بومگردی'
  }

  const houseCount =
    data?.pagination.total && data?.pagination.total > 1
      ? ` بین ${toPersian(data?.pagination.total)} ${unit}`
      : ''

  if (type === 'اقامتگاه بوم گردی') {
    reserveText = 'رزرو'
  }

  if (placeName) {
    return `اجاره روزانه خانه و سوئیت در ${placeName} تهران از ${minPrice} تومان${houseCount} ${shabTitle}`
  }

  if (queryParams.parent_id) {
    const parentTitle = `${getParentDetails(data)} ${shabTitle}`

    return parentTitle
  }

  if (village) {
    return `اجاره ویلا، سوئیت و کلبه در ${village} از ${minPrice} تومان${houseCount} ${shabTitle}`
  }

  if (queryParams.mid_term && mainQueryLength(queryParams) <= 1) {
    return `${reserveText} ${type} در ${city} بدون ودیعه ${shabTitle}`
  }
  const seoFilterTextData = seoFilterText(queryParams)
  const hasSeoTextInType = type.includes(seoFilterTextData as string)
  const texts = {
    city: `${reserveText} ${
      hasSeoTextInType ? type : `${type} ${seoFilterTextData}`
    } در ${city} از ${minPrice} تومان${houseCount} ${shabTitle}`,
    province: `${reserveText} ${
      hasSeoTextInType ? type : `${type} ${seoFilterTextData}`
    } در استان ${province} از ${minPrice} تومان${houseCount} ${shabTitle}`,
    filtered: `${reserveText} ${
      hasSeoTextInType ? type : `${type} ${seoFilterTextData}`
    } از ${minPrice} تومان${houseCount} ${shabTitle}`,
    village: `${reserveText} ${type} `,
  }

  const title =
    city || province ? (city ? texts.city : texts.province) : texts.filtered

  if (queryParams.near_cities) {
    return `اجاره ویلا اطراف ${queryParams.near_cities} از ${minPrice} تومان${houseCount} ${shabTitle}`
  }

  if (mainQueryLength(queryParams) > 1) {
    return `${reserveText} ${type} از ${minPrice} تومان${city || province ? ` در ${city || province}` : ''}${houseCount} ${shabTitle}`
  }

  return title.replace(/\s{2,}/g, ' ').trim()
}

export const getDescription = ({
  queryParams,
  city,
  province,
  data,
  minPrice,
  href,
  placeName,
  village,
}) => {
  const type = getFilteredText(queryParams)
  let reserveText = 'اجاره'

  if (type === 'اقامتگاه بوم گردی') {
    reserveText = 'رزرو'
  }

  if (placeName) {
    return `اجاره روزانه خانه و سوئیت در ${placeName} تهران | پشتیبانی، امنیت و نظافت تضمین شده | بیمه رایگان سفر و اقامت ${!isWhiteLabel ? '| شب' : ''}، برنده تندیس بهترین سایت اجاره ویلا`
  }

  if (queryParams.near_cities) {
    return `اجاره ویلا و سوئیت در اطراف ${queryParams.near_cities} | پشتیبانی، امنیت و نظافت تضمین شده | بیمه رایگان سفر و اقامت ${!isWhiteLabel ? '| شب' : ''}، برنده تندیس بهترین سایت اجاره ویلا`
  }

  if (village) {
    return `اجاره ویلا، سوئیت و کلبه در ${village} | امنیت و نظافت تضمین شده | بیمه رایگان سفر و اقامت | پشتیبانی 24ساعته | تجربه اقامتی خاطره انگیز | Shab.ir`
  }

  if (queryParams.mid_term && mainQueryLength(queryParams) <= 1) {
    return `اجاره ماهانه خانه و آپارتمان مبله ارزان و لوکس در ${city} | امنیت و نظافت تضمین شده | بیمه رایگان سفر و اقامت | پشتیبانی 24ساعته | تجربه اقامتی خاطره انگیز | Shab.ir`
  }

  if (convertUrlToParamsObject(href).parent_id) {
    const parentDescription = `${getParentDetails(data)} با ${
      data.pagination?.total
    } اتاق از ${minPrice} تومان | رزرو ${data?.parent?.title} | سایت شب`

    return parentDescription
  }
  const seoFilterTextData = seoFilterText(queryParams)
  const hasSeoTextInType = type.includes(seoFilterTextData as string)

  const texts = {
    city: `${reserveText} ${
      hasSeoTextInType ? type : `${type} ${seoFilterTextData}`
    } ارزان و لوکس در ${city} | امنیت و نظافت تضمین شده | بیمه رایگان سفر و اقامت | پشتیبانی 24ساعته`,
    province: `${reserveText} ${
      hasSeoTextInType ? type : `${type} ${seoFilterTextData}`
    } ارزان و لوکس در استان ${province} | امنیت و نظافت تضمین شده | بیمه رایگان سفر و اقامت | پشتیبانی 24ساعته`,
    filtered: `${reserveText} ${
      hasSeoTextInType ? type : `${type} ${seoFilterTextData}`
    } ارزان و لوکس | امنیت و نظافت تضمین شده | بیمه رایگان سفر و اقامت | پشتیبانی 24 ساعته`,
  }

  const description =
    city || province ? (city ? texts.city : texts.province) : texts.filtered

  if (mainQueryLength(queryParams) > 1) {
    return `${reserveText} ${getFilteredText(
      queryParams,
    )} ارزان و لوکس ${city || province ? `در ${city || province}` : ''} | امنیت و نظافت تضمین شده | بیمه رایگان سفر و اقامت | پشتیبانی 24 ساعته`
  }

  return description.replace(/\s{2,}/g, ' ').trim()
}
